// Author PanYuRou
// Date 2023-11-06 12:42:59

class EmEmAdmUserGroupRole {
constructor({
        id = null,
        userGroupId = '',
        roleId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.userGroupId = userGroupId;
    this.roleId = roleId;
    this.remark = remark;
}
}

function newEntity() {
return new EmEmAdmUserGroupRole();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emEmAdmUserGroupRole.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'userGroupId',
        label: 'label.em.admin.emEmAdmUserGroupRole.grid.userGroupId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'roleId',
        label: 'label.em.admin.emEmAdmUserGroupRole.grid.roleId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emEmAdmUserGroupRole.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    userGroupIdFilter : '',
    roleIdFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'userGroupIdFilter',
        label: 'label.em.admin.emEmAdmUserGroupRole.filter.userGroupId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'roleIdFilter',
        label: 'label.em.admin.emEmAdmUserGroupRole.filter.roleId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'userGroupId',
        label: 'label.em.admin.emEmAdmUserGroupRole.entity.userGroupId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'roleId',
        label: 'label.em.admin.emEmAdmUserGroupRole.entity.roleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emEmAdmUserGroupRole.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmEmAdmUserGroupRole, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
